/**
 * Scrolls the viewport to the top of the platform overview section.
 * Used when paginating so the user lands at the start of the new page's results.
 */
export const scrollToPlatformOverview = () => {
  const target =
    document.getElementById("plattformen") ?? document.getElementById("portale");
  if (!target) return;
  const headerOffset = 120; // sticky navigation + section nav clearance
  const top = target.getBoundingClientRect().top + window.scrollY - headerOffset;
  window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
};
